import { OrderingOperations, OrderingSelectors } from 'polygon-ordering';
import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import OffersCard from '../components/OffersCard';
import {
  getShowExpiredCoupons,
  getShowRedeemedCoupons,
  getShowUnstartedCoupons,
} from '../libs/polygon-ordering/src/selectors/config';
import getProfile from '../selectors/getProfile';
import { updateLoadingDependencies } from '../slices/loadingDependencies';

const { fetchMemberOffers } = OrderingOperations;
const { getMemberOffers } = OrderingSelectors;

export const OFFERS_ROUTE = '/offers';

const OffersScreen: React.FC = () => {
  const dispatch = useAppDispatch();
  const offers = useAppSelector(getMemberOffers);
  const profile = useAppSelector(getProfile);
  const { verified } = profile!;

  const showRedeemedCoupons = useAppSelector(getShowRedeemedCoupons);
  const showUnstartedCoupons = useAppSelector(getShowUnstartedCoupons);
  const showExpiredCoupons = useAppSelector(getShowExpiredCoupons);

  const [sortedOffers, setSortedOffers] = useState<MemberOffer[]>([]);

  useEffect(() => {
    let sortedOffersTemp = (offers && [...offers]) || [];

    // Sort it by expired, unstarted and redeemed
    sortedOffersTemp = sortedOffersTemp.filter(offer => {
      if (!showExpiredCoupons && offer.expired) {
        return false;
      }
      if (!showUnstartedCoupons && offer.unstarted) {
        return false;
      }

      return true;
    });

    setSortedOffers(sortedOffersTemp);
  }, [offers, showExpiredCoupons, showRedeemedCoupons, showUnstartedCoupons]);

  useEffect(() => {
    if (verified) {
      if (offers === undefined) {
        dispatch(updateLoadingDependencies({ fetchingOffers: true }));
      }

      setTimeout(() => {
        dispatch(fetchMemberOffers({ showRedeemedCoupons })).finally(() => {
          dispatch(updateLoadingDependencies({ fetchingOffers: false }));
        });
      });
    }
  }, [verified]);

  return (
    <div className="text-center" style={{ marginTop: 10 }}>
      {<>{sortedOffers?.map((offer, i) => <OffersCard offer={offer} key={`offer-${i}`} />)}</>}
    </div>
  );
};

export default OffersScreen;
